import { PAYROLL_ADJ_ALL, PAYROLL_ADJ_POST, PAYROLL_ADJ_LOADING, PAYROLL_ADJ_ERROR } from '../types';
import api from '../../../utils/functions/api';

const BASE = `${process.env.REACT_APP_API_URL}/payroll-adjustment`;

export const payrollAdjAll = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: PAYROLL_ADJ_LOADING });
    const { data } = await api.get(BASE, { params });
    dispatch({ type: PAYROLL_ADJ_ALL, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: PAYROLL_ADJ_ERROR });
  }
};

export const payrollAdjUpsert = (payload) => async (dispatch) => {
  try {
    const { data } = await api.post(BASE, payload);
    // ไม่ dispatch กลับ Redux — form เป็น source of truth ระหว่าง session
    // dispatch ครั้งต่อไปจะเกิดเมื่อ payrollAdjAll ถูกเรียกใหม่ (เปลี่ยนเดือน/refresh)
    return data;
  } catch (error) {
    dispatch({ type: PAYROLL_ADJ_ERROR });
    throw error;
  }
};
